/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import router from '../router'

const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    /*updateUserInfo({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload)
    },*/
    initAuth({commit}) {
      //alert(info)
      if (localStorage.getItem('tokenId')) {
        let veriler=JSON.parse(localStorage.getItem('userInfo'))
        commit('setToken',veriler[0])
        router.push('/')
      } else {
        router.push('/login')
      }
      
    },
    login({ commit,state }, payload){

      //console.log(payload.userDetails.email
      var vm = this
      var vs=payload.vs
      const soap = require('soap')
      const url = state.serviceAddress
      const args = {userName: payload.userDetails.email,password:payload.userDetails.password}
      soap.createClient(url, function(err, client){
      client.kullaniciGirisi(args, function(err, result){
      vm.veriler=JSON.parse(result.kullaniciGirisiResult)
      if (vm.veriler=='-1') {
      vs.notify({
        title: 'Hatalı Giriş',
        text: "Hatalı",
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    } else {
      vs.notify({
        title: 'Giriş Başarılı',
        text: "Lütfen Bekleyin Yönlendirileceksiniz.",
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
      //alert(vm.veriler[0])
      commit('setToken',vm.veriler[0])
      localStorage.setItem('tokenId',vm.veriler[0].tokenId)
      
      localStorage.setItem('userInfo',result.kullaniciGirisiResult)
     // localStorage.setItem('plasiyer',vm.veriler[0].plasiyer)
     // localStorage.setItem('serkan',vm.veriler[0].id)
     // console.log(vm.veriler[0].plasiyer)
    }
   router.push('/')
      });
      });

    },
    logout({commit}) {
      commit('clearToken')
      router.push('/login')
    }
   
}

export default actions
